import axios from 'axios';

import { Id, NamedEntity, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Discipline, DisciplineRequest } from './DisciplineTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Discipline>>('/disciplines/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Discipline>(`/disciplines/${id}`).then(getData);
}

export function getDisciplines() {
  return axios.get<Discipline[]>('/disciplines').then(getData);
}

export function getDisciplinesByDepartment(departmentId: Id) {
  return axios.get<Discipline[]>(`/disciplines/for-department/${departmentId}`).then(getData);
}

export function getDisciplinesAsHeadOf() {
  return axios.get<Discipline[]>('/disciplines/where-head-of').then(getData);
}

export function getDisciplineUsers(disciplineId: Id) {
  return axios.get<NamedEntity[]>(`/disciplines/${disciplineId}/users`).then(getData);
}

export function create(request: DisciplineRequest) {
  return axios.post<Discipline>(`/disciplines`, request).then(getData);
}

export function edit(id: Id, request: DisciplineRequest) {
  return axios.put<Discipline>(`/disciplines/${id}`, request).then(getData);
}
